import AlertRules from "./AlertRules.js";
export default {
  install: molten => {
    molten.addPlugin('Molten.blueprintRelationshipProcessor', {
      id: 'alertRules.routes',
      type: 'alertRules.routes',
      processRelationship: AlertRules
    });
  }
};